import { createPrefixedActions } from '@zapier/toolbox-redux-framework';

export default createPrefixedActions(
  'developer',
  `
    SET_SAVED_STATE

    SET_SAVE_ERROR_MESSAGE

    SET_CURRENT_APP
    SET_CURRENT_CLI_APP_ID
    SET_CURRENT_ISSUE_ID

    CHANGE_DEVELOPER_NOTIFICATIONS
    CHANGE_DEVELOPER_NOTIFICATIONS_DONE
    CHANGE_DEVELOPER_NOTIFICATIONS_FAIL

    CHANGE_CC_CONTACT_EMAIL

    SAVE_CC_CONTACT_EMAIL
    SAVE_CC_CONTACT_EMAIL_DONE
    SAVE_CC_CONTACT_EMAIL_FAIL

    SUBMIT_NEW_COMMENT
    SUBMIT_NEW_COMMENT_DONE
    SUBMIT_NEW_COMMENT_FAIL

    UPDATE_ASSIGNEE
    UPDATE_ASSIGNEE_DONE
    UPDATE_ASSIGNEE_FAIL

    UPDATE_COMMENT
    UPDATE_COMMENT_DONE
    UPDATE_COMMENT_FAIL

    SET_CURRENT_CLI_APP_VERSION

    LOAD_APP_EVENT_STATS
    LOAD_APP_EVENT_STATS_DONE
    LOAD_APP_EVENT_STATS_FAIL

    LOAD_APP_NOTIFICATION_SETTINGS
    LOAD_APP_NOTIFICATION_SETTINGS_DONE
    LOAD_APP_NOTIFICATION_SETTINGS_FAIL

    LOAD_APP_EVENTS
    LOAD_APP_EVENTS_DONE
    LOAD_APP_EVENTS_FAIL

    LOAD_LOKI_TAGS
    LOAD_LOKI_TAGS_DONE
    LOAD_LOKI_TAGS_FAIL

    TOGGLE_ISSUE_TAG
    TOGGLE_ISSUE_TAG_DONE
    TOGGLE_ISSUE_TAG_FAIL

    TOGGLE_ISSUE_ACTION
    TOGGLE_ISSUE_ACTION_DONE
    TOGGLE_ISSUE_ACTION_FAIL

    SET_EDITING_SIDEBAR_SECTION

    LOAD_APP_ISSUE
    LOAD_APP_ISSUE_DONE
    LOAD_APP_ISSUE_FAIL

    LOAD_APP_ISSUES
    LOAD_APP_ISSUES_DONE
    LOAD_APP_ISSUES_FAIL

    CHANGE_COMMENT

    START_COMMENT_EDIT
    STOP_COMMENT_EDIT

    CLEAR_APP_EVENTS

    LOAD_TAGGABLE_USERS
    LOAD_TAGGABLE_USERS_DONE
    LOAD_TAGGABLE_USERS_FAIL

    LOAD_APP_DEPLOY_STATUS
    LOAD_APP_DEPLOY_STATUS_DONE
    LOAD_APP_DEPLOY_STATUS_FAIL

    LOAD_APP_DEPLOY_HISTORY
    LOAD_APP_DEPLOY_HISTORY_DONE
    LOAD_APP_DEPLOY_HISTORY_FAIL

    CLONE_APP
    CLONE_APP_DONE
    CLONE_APP_FAIL

    CLEAR_CLONE_APP_ID

    LOAD_APP_USAGE_STATS
    LOAD_APP_USAGE_STATS_DONE
    LOAD_APP_USAGE_STATS_FAIL

    DELETE_APP
    DELETE_APP_DONE
    DELETE_APP_FAIL

    LOAD_DELETED_APPS
    LOAD_DELETED_APPS_DONE
    LOAD_DELETED_APPS_FAIL

    CLEAR_DEV_ERRORS

    CLEAR_DEV_ERRORS_SCROLL

    CREATE_DEV_APP
    CREATE_DEV_APP_DONE
    CREATE_DEV_APP_FAIL

    UPDATE_CREATE_DEV_APP_FORM

    GET_APP_DELETE_STATUS
    GET_APP_DELETE_STATUS_DONE
    GET_APP_DELETE_STATUS_FAIL

    UPDATE_META_DEV_APP_FORM
    UPDATE_META_DEV_CLI_APP_FORM
    UPDATE_CLI_ADD_ADMIN_FORM
    UPDATE_CLI_ADD_INVITEE_FORM
    UPDATE_APP_ACTIVATION_FORM

    SUBMIT_NEW_TEAM_MEMBER
    SUBMIT_NEW_TEAM_MEMBER_DONE
    SUBMIT_NEW_TEAM_MEMBER_FAIL
    UPDATE_NEW_TEAM_MEMBER
    RESET_NEW_TEAM_MEMBER_FORM

    CREATE_MESSAGE
    CLEAR_MESSAGE

    UPDATE_DEV_APP

    UPDATE_DEV_APP_META
    UPDATE_DEV_APP_META_DONE
    UPDATE_DEV_APP_META_FAIL

    UPDATE_DEV_APP_META_IMAGE
    UPDATE_DEV_APP_META_IMAGE_DONE
    UPDATE_DEV_APP_META_IMAGE_FAIL

    UPDATE_DEV_CLI_APP_META_IMAGE
    UPDATE_DEV_CLI_APP_META_IMAGE_DONE
    UPDATE_DEV_CLI_APP_META_IMAGE_FAIL

    UPDATE_DEVELOPER_APP_BACKBONE_DATA

    GET_DEV_APP_FORM
    GET_DEV_APP_FORM_DONE
    GET_DEV_APP_FORM_FAIL

    LOAD_CLI_APP_USAGE
    LOAD_CLI_APP_USAGE_DONE
    LOAD_CLI_APP_USAGE_FAIL

    LOAD_CLI_APP_STATS
    LOAD_CLI_APP_STATS_DONE
    LOAD_CLI_APP_STATS_FAIL

    SUBMIT_APP_ACTIVATION_FORM
    SUBMIT_APP_ACTIVATION_FORM_DONE
    SUBMIT_APP_ACTIVATION_FORM_FAIL

    PROMOTE_CLI_APP
    PROMOTE_CLI_APP_DONE
    PROMOTE_CLI_APP_FAIL

    CLEAR_PROMOTE_CLI_APP_ERRORS

    DELETE_ZAP_TEMPLATE
  `
);
